import { render, staticRenderFns } from "./UiFlag.vue?vue&type=template&id=0ccc900b"
import script from "./UiFlag.vue?vue&type=script&lang=js"
export * from "./UiFlag.vue?vue&type=script&lang=js"
import style0 from "./UiFlag.vue?vue&type=style&index=0&id=0ccc900b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports